export const ANSWER_TABLE_START_OFFSET = 0;
